// Thin wrapper around @vite-pwa/nuxt's $pwa helper.
//
// Used together with workbox.skipWaiting: true (see nuxt.config.ts) which
// makes new SWs auto-activate on install — so by the time we apply an update
// the SW is already the active one and we just need to reload the page.
//
// pokeUpdate()      — fire-and-forget; tells the active SW to re-check sw.js
//                     now. Browsers otherwise only check on navigation, capped
//                     at 24h. POS tabs stay open all shift and would never
//                     re-check on their own.
// applyUpdate()     — reload the tab. The active SW (the new one) serves the
//                     new precache.
// newVersionReady  — true once a new SW has installed.

export function usePwaUpdate() {
  const { $pwa } = useNuxtApp() as any

  const newVersionReady = computed<boolean>(() => !!$pwa?.needRefresh)

  async function pokeUpdate(): Promise<void> {
    if (!('serviceWorker' in navigator)) return
    if (!navigator.onLine) return
    try {
      const reg = await navigator.serviceWorker.getRegistration()
      await reg?.update()
    } catch {
      // silent — periodic poll will retry
    }
  }

  async function applyUpdate(): Promise<void> {
    window.location.reload()
  }

  return { newVersionReady, pokeUpdate, applyUpdate }
}
